import type { insuranceMonitorApiSpec } from "@wingspanhq/wingspan-api-types";
import { monitorService } from "./service";

type InsuranceCoverageMonitor =
  insuranceMonitorApiSpec.InsuranceCoverageMonitor;

export const getInsuranceCoverageMonitor = async (
  monitorId: string
): Promise<InsuranceCoverageMonitor> => {
  const { data } = await monitorService.get<InsuranceCoverageMonitor>(
    `/${monitorId}`
  );

  return data;
};
